module.exports = __webpack_public_path__ + "static/img/2.a974ea8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/2.png
// module id = oN5O
// module chunks = 0